

//  Derives quiz level from quiz title
export const getLevelFromTitle = (title = "") => {
  const lower = title.toLowerCase();

  if (lower.includes("beginner")) return "beginner";
  if (lower.includes("intermidiate")) return "intermidiate";
  if (lower.includes("advance")) return "advanced";

  return null;
};

/**
 * Resolves assessment metadata based on technology & level
 * Fallback: beginner level of same technology
 */
export const resolveAssessmentMetaData = ({
  metaData,
  quizTechnology,
  quizTitle
}) => {
  if (!metaData || !quizTechnology) return null;

  const level = getLevelFromTitle(quizTitle);

  // 1️⃣ Exact match: technology + level
  if (level) {
    const exactMatch = metaData.find(
      (item) =>
        item.technology.toLowerCase() === quizTechnology &&
        item.level.toLowerCase() === level
    );

    if (exactMatch) return exactMatch;
  }

  // 2️⃣ Fallback: beginner level of same technology
  const beginnerFallback = metaData.find(
    (item) =>
      item.technology === quizTechnology &&
      item.level === "beginner"
  );

  return beginnerFallback || null;
};
